// GAVION tasks page: « Nouvelle tâche » on /tasks (a compagnie, optionally a contact).
export const tasksFr = {
  new: "Nouvelle tâche",
  company: "Compagnie",
  contact_optional: "Contact (facultatif)",
  assigned_to: "Assignée à",
  reassign: "Réassigner",
  reassigned: "Tâche réassignée à %{name}",
  assigned_current: "actuelle",
  // GAVION task actions: work an open task from /tasks without opening the compagnie
  actions: {
    group: "Actions sur la tâche « %{task} »",
    call: "Appeler",
    email: "Courriel",
    note: "Noter",
    context: "Contexte",
  },
  note: {
    title: "Noter",
    mark_done: "Marquer la tâche faite",
    off_crm: "Appel fait en dehors du CRM",
  },
  context: {
    title: "Contexte",
    company: "Compagnie",
    status: "Statut",
    phone: "Téléphone",
    email: "Courriel",
    rep: "Représentant",
    unassigned: "Non assignée",
    deal: "Deal",
    stage: "Étape",
    amount: "Montant",
    history: "Historique récent",
    open_company: "Ouvrir la fiche",
  },
};
